import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import { AccordionDetails, Badge, Tooltip } from "@material-ui/core";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import SpecDeckBeamPostTool from "./SpecDeckBeamPostTool";
import DeckDesignTools from "./SpecDeckDesignTools";
import ShapeJoinTools from "../SpecShapeJoinTools";
import _debounce from "lodash/debounce";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CrossCircleIcon from "@material-ui/icons/Cancel";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import CachedIcon from "@material-ui/icons/Cached";
import AssignmentLateIcon from "@material-ui/icons/AssignmentLate";
import { connect } from "react-redux";
import { addNewArea, deleteArea, updateJobParameter } from "../../../redux_store/jobState";
import { changePage, toggleDesigner, toggle3DDesigner, update3DDesigner } from "../../../redux_store/appState";
import { setToolSetArea } from "../../../redux_store/appStateHelper";
import * as APP from "../../../redux_store/appState";
import AreaSelector from "../AreaSelector";
import BSL_SlidingView from "../../../components/BSL_SlidingView";
import { Palette } from "../../../AppConfig";
import BSL_Button from "../../../components/BSL_Button";
import SpecOtherTools from "../SpecOtherTools";
import { BSL_DialogData } from "../../../components/BSL_Dialog";
import { GetShapeUpdateString } from "../../layout/PaperFunctionHelper";
import { LockDiv } from "../SpecToolAccordian";

const importedActions = {
    changePage,
    toggleDesigner,
    toggle3DDesigner,
    update3DDesigner,
    setToolSetArea,
    addNewArea,
    deleteArea,
};
const mapStateToProps = (state) => ({
    app: state.app,
    job: state.job,
});

const StyledAccordion = withStyles({
    root: {
        background: "none",
    },
    expanded: {
        margin: "0px !important",
        minHeight: "24px",
    },
})(Accordion);

const StyledAccordionSummary = withStyles({
    root: {
        minHeight: "24px",
        paddingLeft: "12px",
    },
    content: {
        marginTop: "9px",
        marginBottom: "9px",
    },
    expanded: {
        minHeight: "24px",
    },
})(AccordionSummary);

const styles = (theme) => ({
    root: {
        width: "100%",
        overflow: "hidden auto",
        display: "flex",
        flexDirection: "column",
        flex: 1,
    },
    heading: {
        font: "14pt 'Univers45', sans-serif",
        flexShrink: 0,
        color: Palette.Control.FieldersDarkBlue,
    },
    panel: {
        width: "100%",
    },
    panelSummary: {},
    panelsExpanded: {
        margin: "0px !important",
    },
    panelHeading: {
        minHeight: "24px",
        margin: "0",
        zIndex: 10,
    },
    panelSummaryExpanded: {
        margin: "0",
    },
    details: {
        flexDirection: "column",
        padding: "0px 0px",
    },
    secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
    },
    toolMenuText: {
        color: "white",
        textAlign: "right",
    },
    tabsRoot: {
        backgroundColor: "white",
        color: "black",
    },
    tabRoot: {
        minWidth: "0",
        width: "100%",
    },
    tabContainer: {
        minWidth: "0",
        flex: "1",
    },

    cover_start: {
        left: "0px",
        top: "0px",
        width: "30%",
        height: "100%",
        position: "absolute",
        backgroundImage: "linear-gradient(to right, rgba(0,0,0,0.5), rgba(0,0,0,0.1))",
        zIndex: 1,
    },
    cover_end: {
        right: "0px",
        top: "0px",
        width: "30%",
        height: "100%",
        position: "absolute",
        backgroundImage: "linear-gradient(to right, rgba(0,0,0,0.1), rgba(0,0,0,0.5))",
        zIndex: 1,
    },
    addNewBefore: {
        position: "absolute",
        left: "-14px",
        zIndex: 1,
    },
    addNew: {
        position: "absolute",
        right: "-14px",
        zIndex: 1,
    },
    deleteArea: {
        right: "26px",
        top: "-14px",
        zIndex: 1,
        padding: "0",
        width: "0px",
    },
    slide: {
        minHeight: 100,
        color: "#fff",
        overflow: "none",
        flex: "1 0 100%",
        borderRight: "1px solid grey",
        maxWidth: "100%",
    },
    no_border: {
        border: "none",
    },
    slim_panel: {
        maxWidth: "250px",
        width: "250px",
    },
    lockOverlay: {
        left: "0px",
        right: "0px",
        top: "48px",
        bottom: "0px",
        position: "absolute",
        backgroundImage: "linear-gradient(to right, rgba(0,0,0,0.1), rgba(0,0,0,0.3))",
        zIndex: 1,
        color: "white",
        verticalAlign: "middle",
    },
    lockText: {
        background: "#33333380",
        width: "100%",
        padding: "20px",
        marginTop: "150px",
    },
});

function SpecDecks(props) {
    const dispatch = useDispatch();
    const scrollEl = React.useRef(null);
    const { classes, job, setToolSetArea, addNewArea, openMessageBox } = props;

    const DRAWER_TOOLSET_EXPANDED = props.app.designer.designer3D[APP.DRAWER_TOOLSET_EXPANDED];

    let areaIndex = props.app.designer[APP.TOOL_DRAWER_AREA];
    if (areaIndex >= job.AreaSpecifications.length) areaIndex = job.AreaSpecifications.length - 1;

    const [selectedIndex, setSelectedIndex] = React.useState(areaIndex);
    const [scrollLeft, setScrollLeft] = React.useState(0);
    const [dialogData, setDialogData] = React.useState(null);

    let selectedAreaIndex = selectedIndex !== null ? selectedIndex : areaIndex;
    if (selectedAreaIndex >= job.AreaSpecifications.length) selectedAreaIndex = job.AreaSpecifications.length - 1;

    React.useEffect(() => {
        setSelectedIndex(areaIndex);
    }, [areaIndex]);

    const updateArea = React.useCallback(
        _debounce((newValue, tool) => {
            dispatch(setToolSetArea(newValue, tool));
        }, 1500),
        []
    );

    if (job.AreaSpecifications.length === 0) {
        return (
            <div className={classes.root}>
                <div
                    style={{
                        width: "100%",
                        height: "400px",
                        paddingTop: "250px",
                    }}
                >
                    <BSL_Button tight label="Add Area" onClick={() => addNewArea(false)} />
                </div>
            </div>
        );
    }

    const handleSelectedIndexChanged = (newValue, tool = null) => {
        updateArea(newValue, tool);
        setSelectedIndex(newValue);
    };

    let num_areas = job.AreaSpecifications.length;

    const currentHashCode = GetShapeUpdateString(false, true);

    let multi_view = false;
    if (props.width?.width && props.width?.width > 400) {
        multi_view = true;
    }

    let panel_classes = classes.slide;
    if (multi_view) panel_classes = classes.slide + " " + classes.slim_panel;

    if (!multi_view && scrollEl?.current) {
        scrollEl.current.scrollLeft = 0;
    }

    const onScroll = (e) => {
        if (e.target.scrollLeft !== scrollLeft) setScrollLeft(e.target.scrollLeft);
    };

    let MaxOverallCapacity = 0;

    if (job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]) {
        if (job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.MaxOverallCapacity)
            MaxOverallCapacity = job?.QuoteParameters?.ENGINEERING?.Data?.[areaIndex]?.MaxOverallCapacity;
    }

    let engineeringStatus = "unknown";
    if (MaxOverallCapacity > 0) {
        engineeringStatus = MaxOverallCapacity <= 1 ? "pass" : "fail";
    }

    props.setEngineeringStatus(engineeringStatus);

    let supplementaryEngineering = [];
    if (job?.SupplementaryEngineering && job?.SupplementaryEngineering.length > 0) {
        for (let supp of job?.SupplementaryEngineering) supplementaryEngineering.push(<li>{supp}</li>);
    }

    const handleOnClickBeamsAndPosts = async () => {
        props.setEngineeringLoading(true);
        setSelectedIndex(Math.trunc(areaIndex));
        await setToolSetArea(
            areaIndex,
            DRAWER_TOOLSET_EXPANDED === APP.BEAMS_AND_POSTS_TOOL ? "none" : APP.BEAMS_AND_POSTS_TOOL
        );
        props.setEngineeringLoading(false);
    };

    return (
        <div className={classes.root}>
            <div style={{ background: "#F4F4F4", marginLeft: -scrollLeft + "px" }}>
                <AreaSelector
                    multi_view={multi_view}
                    page={DRAWER_TOOLSET_EXPANDED}
                    showHeader={true}
                    selectedAreaIndex={selectedAreaIndex}
                    onChange={props.multi_view ? null : handleSelectedIndexChanged}
                />
            </div>
            <div
                style={{
                    flex: "1",
                    overflowX: multi_view ? "auto" : "hidden",
                    overflowY: "auto",
                }}
                ref={scrollEl}
                onScroll={onScroll}
            >
                <StyledAccordion
                    expanded={DRAWER_TOOLSET_EXPANDED === APP.SHAPE_TOOL}
                    onChange={() =>
                        setToolSetArea(areaIndex, DRAWER_TOOLSET_EXPANDED === APP.SHAPE_TOOL ? "none" : APP.SHAPE_TOOL)
                    }
                    style={multi_view ? { width: "max-content" } : {}}
                >
                    <StyledAccordionSummary
                        className={
                            classes.panelHeading +
                            (DRAWER_TOOLSET_EXPANDED === APP.SHAPE_TOOL ? " " + classes.panelSummaryExpanded : "")
                        }
                        expandIcon={<ExpandMoreIcon />}
                        style={
                            multi_view ? { width: props.width?.width ? props.width?.width - 18 : "max-content" } : {}
                        }
                    >
                        <Typography className={classes.heading} style={{ marginLeft: scrollLeft + "px" }}>
                            SHAPE / DIMENSIONS / WALL / FLOOR
                        </Typography>
                    </StyledAccordionSummary>
                    <AccordionDetails className={classes.details}>
                        <LockDiv classes={classes} openMessageBox={openMessageBox} />
                        <BSL_SlidingView index={multi_view ? 0 : selectedAreaIndex * 2}>
                            {job.AreaSpecifications.map((area, index) => [
                                <div
                                    key={index}
                                    value={areaIndex}
                                    index={index}
                                    className={panel_classes + " " + (index >= num_areas - 1 ? classes.no_border : "")}
                                >
                                    <DeckDesignTools key={index} areaIndex={index} />
                                </div>,
                                <div
                                    key={100 + index}
                                    className={classes.slide + " " + (index >= num_areas - 1 ? "hidden" : "")}
                                    value={areaIndex}
                                    index={index + 0.5}
                                    style={multi_view ? { maxWidth: "165px" } : {}}
                                >
                                    <ShapeJoinTools key={index} areaIndex={index} />
                                </div>,
                            ])}
                        </BSL_SlidingView>
                    </AccordionDetails>
                </StyledAccordion>

                {job?.OverrideEngineering && (
                    <div
                        style={{
                            width: "100%",
                            background: "#1a3061",
                            color: "white",
                            textTransform: "uppercase",
                        }}
                    >
                        {job?.OverrideEngineering}
                        <IconButton
                            aria-label="delete"
                            size="small"
                            onClick={() => {
                                dispatch(updateJobParameter("OverrideEngineering", false));
                            }}
                            style={{ color: "#dddddd" }}
                        >
                            <ClearIcon fontSize="inherit" />
                        </IconButton>
                    </div>
                )}
                {job?.AcceptedWarnings &&
                    job.AcceptedWarnings.map((warning) => (
                        <div
                            style={{
                                width: "100%",
                                background: "#1a3061",
                                color: "white",
                                textTransform: "uppercase",
                            }}
                        >
                            {warning}
                            <IconButton
                                aria-label="delete"
                                size="small"
                                onClick={() => {
                                    dispatch(
                                        updateJobParameter(
                                            "AcceptedWarnings",
                                            job.AcceptedWarnings.filter((e) => e !== warning)
                                        )
                                    );
                                }}
                                style={{ color: "#dddddd" }}
                            >
                                <ClearIcon fontSize="inherit" />
                            </IconButton>
                        </div>
                    ))}
                <StyledAccordion
                    expanded={DRAWER_TOOLSET_EXPANDED === APP.BEAMS_AND_POSTS_TOOL}
                    onChange={() => {
                        handleOnClickBeamsAndPosts();
                    }}
                >
                    <StyledAccordionSummary
                        className={
                            classes.panelHeading +
                            (DRAWER_TOOLSET_EXPANDED === APP.BEAMS_AND_POSTS_TOOL
                                ? " " + classes.panelSummaryExpanded
                                : "")
                        }
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography className={classes.heading}>
                            <Tooltip
                                title={
                                    "Max Capacity: " +
                                    (MaxOverallCapacity ? Math.trunc(MaxOverallCapacity * 100) + "%" : "??")
                                }
                            >
                                {MaxOverallCapacity > 0 && !props.engineeringLoading ? (
                                    MaxOverallCapacity <= 1 ? (
                                        <CheckCircleIcon style={{ color: "#008200", verticalAlign: "top" }} />
                                    ) : (
                                        <CrossCircleIcon style={{ color: "#8c1212", verticalAlign: "top" }} />
                                    )
                                ) : (
                                    <CachedIcon
                                        style={{
                                            color: "#b37f0b",
                                            verticalAlign: "top",
                                            animation: props.engineeringLoading ? "spin 1s linear infinite" : "",
                                        }}
                                    />
                                )}
                            </Tooltip>
                            {job?.SupplementaryEngineering && job?.SupplementaryEngineering.length > 0 && (
                                <Tooltip
                                    title={
                                        <>
                                            Supplementary Engineering Required:
                                            <br />
                                            <ul>{supplementaryEngineering}</ul>
                                        </>
                                    }
                                    onClick={() => {
                                        setDialogData({
                                            title: "Supplementary Engineering Required:",
                                            message: [<ul>{supplementaryEngineering}</ul>],
                                            onClose: () => setDialogData(null),
                                        });
                                    }}
                                >
                                    <Badge
                                        badgeContent={job?.SupplementaryEngineering.length}
                                        color="secondary"
                                        style={{
                                            marginRight: "12px",
                                        }}
                                    >
                                        <AssignmentLateIcon
                                            style={{
                                                color: "#a66b00",
                                                verticalAlign: "top",
                                            }}
                                        />
                                    </Badge>
                                </Tooltip>
                            )}
                            BEAMS & POSTS
                        </Typography>
                    </StyledAccordionSummary>
                    <AccordionDetails className={classes.details}>
                        <LockDiv classes={classes} openMessageBox={openMessageBox} />
                        <BSL_SlidingView index={multi_view ? 0 : Math.floor(selectedAreaIndex)}>
                            {job.AreaSpecifications.map((area, index) => (
                                <div
                                    key={index}
                                    value={areaIndex}
                                    index={index}
                                    className={panel_classes + " " + (index >= num_areas - 1 ? classes.no_border : "")}
                                >
                                    <SpecDeckBeamPostTool currentHashCode={currentHashCode} areaIndex={index} />
                                </div>
                            ))}
                        </BSL_SlidingView>
                    </AccordionDetails>
                </StyledAccordion>

                <StyledAccordion
                    expanded={DRAWER_TOOLSET_EXPANDED === APP.OTHER_TOOLS}
                    onChange={() => {
                        setSelectedIndex(Math.trunc(areaIndex));
                        setToolSetArea(
                            areaIndex,
                            DRAWER_TOOLSET_EXPANDED === APP.OTHER_TOOLS ? "none" : APP.OTHER_TOOLS
                        );
                    }}
                >
                    <StyledAccordionSummary
                        className={
                            classes.panelHeading +
                            (DRAWER_TOOLSET_EXPANDED === APP.OTHER_TOOLS ? " " + classes.panelSummaryExpanded : "")
                        }
                        expandIcon={<ExpandMoreIcon />}
                    >
                        <Typography className={classes.heading}>OTHER TOOLS</Typography>
                    </StyledAccordionSummary>
                    <AccordionDetails className={classes.details}>
                        <LockDiv classes={classes} openMessageBox={openMessageBox} />
                        <BSL_SlidingView index={multi_view ? 0 : Math.floor(selectedAreaIndex)}>
                            {job.AreaSpecifications.map((area, index) => (
                                <div
                                    key={index}
                                    value={areaIndex}
                                    index={index}
                                    className={panel_classes + " " + (index >= num_areas - 1 ? classes.no_border : "")}
                                >
                                    <SpecOtherTools currentHashCode={currentHashCode} areaIndex={index} />
                                </div>
                            ))}
                        </BSL_SlidingView>
                    </AccordionDetails>
                </StyledAccordion>
            </div>

            <BSL_DialogData dialogData={dialogData} dispatch={dispatch} />
        </div>
    );
}

SpecDecks.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, importedActions)(withStyles(styles)(SpecDecks));
